<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem>素材管理 > <b>模板列表</b></BreadcrumbItem>
      </Breadcrumb>
      <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
            <span class="search_span_width">
                <span class="search_span_width_part1">分类：</span>
				 <Select v-model="search.studio_type" style="width:260px">
						<Option value="7" :key="7">AI包装</Option>
						<Option value="25" :key="25">PC模板</Option>
				        <Option value="2" :key="2">客户端直播</Option>
						<Option value="1" :key="1">客户端视频</Option>
						<!-- <Option value="3" :key="3">小程序视频</Option> -->
						<Option value="4" :key="4">AI智能成片</Option>
						<Option value="11" :key="11">商品视频</Option>
				</Select>
            </span>
        <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getStudioList()">搜索</Button>
      </Card>
      <Card>
        <Card id="tableContent" >
          <Table :columns="tableColumns" :data="studio_list"></Table>
		   <Page :total="recordTotal" :current="page" :page-size="30" :show-elevator="true" @on-change="getStudioList"/>
        </Card>
      </Card>
    </Content>
   <Modal v-model="showmodal" :footer-hide=true title="编辑">
        <Form ref="studio" :model="studio" :label-width="80" >
			<FormItem label="标签" prop="tag_id">
				<CheckboxGroup v-model="studio.tag_id" v-for="(item, index) in tag_list" :key="index" >
					{{item.title}}<br/>
				    <Checkbox :label="it.value" v-for="(it,index) in item.children" :key="index">{{it.title}}</Checkbox>
				</CheckboxGroup>
			</FormItem>
            <FormItem label="名称" prop="name">
                <Input v-model="studio.name"  />
            </FormItem>
			<FormItem label="渠道" prop="channel">
				 <Select v-model="studio.channel" style="width:260px">
				 	<Option v-for="(item, index) in channel_list"  :value="item.id" :key="item.id">{{ item.name }}</Option>
				 </Select>
			</FormItem>
			<FormItem label="排序" prop="seq">
			    <Input v-model="studio.seq"  />
			</FormItem>
          <FormItem label="模板展示位置" prop="seq">
            <Select v-model="studio.templet_position"  style="width:250px">
              <Option value="0" :key="0">中文客户端</Option>
              <Option value="1" :key="1">英文客户端</Option>
            </Select>
          </FormItem>
			<FormItem label="封面" prop="cover">
				<img :src="studio.cover" :style="{'width':'100px'}"/>
					<Upload :action="getUploadUrl" :headers="uploadHeader" :on-success="successCover">
			        <Button icon="ios-cloud-upload-outline">上传封面</Button>
			    </Upload>
			</FormItem>  
			<FormItem label="视频地址" prop="logo">
				<video ref="audio" controls="controls" :src="studio.video" width='50%' height="50%"></video>
			    <Upload :action="getUploadUrl" :headers="uploadHeader" :on-success="successUpload">
			        <Button icon="ios-cloud-upload-outline">上传视频</Button>
			    </Upload>
			</FormItem>  
            <FormItem>
                <Button type="primary" @click="updateStudio()">提交</Button>
            </FormItem>
        </Form>
    </Modal>
    <Modal
        v-model="showComponentList"
        title="组件列表"
        footer-hide
        width="1000"
       >
      <Button type="primary" @click="addComponent">新增</Button>
      <Table :columns="componentListColumns" :data="studio_unit_list" style="margin-top:10px;"></Table>
      <Page :total="componentsTotal" :current="componentSearch.page" :page-size="componentSearch.pageSize" :show-elevator="true" @on-change="getStudioUnitList"/>
    </Modal>
    <Modal
        v-model="showComponentAdd"
        title="组件新增"
        footer-hide
        width="800"
    >
      <Form ref="studio" :model="studio" :label-width="150" >
        <FormItem label="名字">
          <Input v-model="componentAddForm.name"  style="width: 300px" />
        </FormItem>
        <FormItem label="场景">
          <Select v-model="componentAddForm.studio_page_id" style="width:300px">
            <Option v-for="item in pageList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>

        <FormItem label="组件类型">
          <Select v-model="componentAddForm.unit_type" style="width:300px">
            <Option v-for="item in unitTypeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
<!--        <FormItem label="素材ID">-->
<!--          <Input v-model="componentAddForm.mat_id"  style="width: 300px" />-->
<!--        </FormItem>-->
        <FormItem>
          <Button type="primary" @click="addStudioUnit()">提交</Button>
        </FormItem>
      </Form>
    </Modal>
    <Modal
        v-model="showComponentEdit"
        title="组件编辑"
        footer-hide
        width="1000"
    >
      <Form ref="studio" :model="studio" :label-width="150" >
        <FormItem label="名字">
          <Input v-model="componentEditForm.name"  style="width: 300px" />
        </FormItem>
        <FormItem label="场景">
          <Select v-model="componentEditForm.studio_page_id" style="width:300px">
            <Option v-for="item in pageList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="组件类型">
          <Select v-model="componentEditForm.unit_type" style="width:300px">
            <Option v-for="item in unitTypeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="属性">
          <Input v-model="componentEditForm.attr" type="textarea" :rows="10" />
        </FormItem>
<!--        <FormItem label="素材ID">-->
<!--          <Input v-model="componentEditForm.mat_id"  style="width: 300px" />-->
<!--        </FormItem>-->
        <FormItem>
          <Button type="primary" @click="editStudioUnit()">提交</Button>
        </FormItem>
      </Form>
    </Modal>
  </Layout>
</template>
<script>
export default {
  data(){
    return {
		search : {
			studio_type:'7',
			tag_id:0
		},
		showmodal:false,
    showComponentList:false,
    showComponentAdd:false,
    showComponentEdit:false,
		studio_list:[],
    studio_unit_list:[],
		tag_list:[],
		channel_list:[],
		page:1,
		pagesize:30,
		recordTotal:0,
		studio:{
			id:0,
			name:'',
			tag_id:[],
			video:'',
			seq:0,
			cover:'',
      templet_position:0,
			channel:'',
      ext_attr:''
		},
    currentStudioId:"",
    componentSearch:{
      studio_id:0,
      page: 1,
      pageSize: 5
    },
    componentAddForm:{
      name:"",
      studio_id: '',
      studio_page_id:'',
      unit_type:'',
      mat_id:'',
    },
    componentEditForm:{
      id:0,
      studio_id: 0,
      studio_page_id:0,
      unit_type:0,
      mat_id:0,
      attr:""
    },
    componentDelForm:{
      id:0,
      studio_id: 0,
      studio_page_id:0
    },
    componentsTotal:0,
    unitTypeList:[],
    pageList:[],
		tableColumns:[
		{ title: '直播间ID', key: 'id', align: 'center' },
		{ title: '名称', key: 'name', align: 'center' },
		{ title: '标签', key: 'tag_id', align: 'center' },
		{ title: '排序', key: 'seq', align: 'center' },
		{ title: '渠道', key: 'channel', align: 'center' },
		{ title: '操作', key: 'action', align: 'center',width:150,
		  render: (h, params) => {
			let btns=[]
			btns.push(
				h('Button', {
				  props: { type: 'primary', size: 'small' },
				  style: { marginRight: '5px', marginBottom: '5px'},
				  on: {
					click: () => {
						this.studio.id = params.row.id;
						this.studio.name = params.row.name;
						this.studio.seq = params.row.seq;
						this.studio.tag_id = params.row.tag_id;
						this.studio.video = params.row.video;
						this.studio.cover = params.row.cover;
						this.studio.channel = params.row.channel;
            this.studio.templet_position = params.row.templet_position;
            this.studio.ext_attr = params.row.ext_attr;
						this.showmodal = true;
					}
				  }
				}, '编辑'),
			);
			btns.push(
				h('Button', {
				  props: { type: 'error', size: 'small' },
				  style: { marginRight: '5px', marginBottom: '5px'},
				  on: {
					click: () => {      
						this.setTemplate(params.row.id,params.row.studio_type);
					}
				  }
				}, '取消模板'),
			);
      btns.push(
          h('Button', {
            props: { type: 'success', size: 'small' },
            style: { marginRight: '5px', marginBottom: '5px'},
            on: {
              click: () => {
                this.showComponentList = true;
                this.componentSearch.studio_id= params.row.id;
                this.currentStudioId = params.row.id;
                this.getStudioUnitList();
                this.getStudioPage();
              }
            }
          }, '组件列表'),
      );
			return h("div",btns);
		  }
		}
		],
    componentListColumns:[ 
      {
        type: 'expand',
        width: 50,
        render: (h, params) =>  {
          return h('div', {
            style: {
              whiteSpace: 'pre-wrap !important',
              wordWrap: 'break-word !important'
            }
          }, params.row.attr)
        }
      },
      { title: '组件ID', key: 'id', align: 'center' },
      { title: '名字', key: 'name', align: 'center' },
      { title: '直播间ID', key: 'studio_id', align: 'center' },
      { title: '组件类型', key: 'unit_type_name', align: 'center' },
      { title: '场景', key: 'title', align: 'center',render: (h,params)=>{
         if(!params.row.title){
            return h("span","【场景】"+params.row.studio_page_id);
         }
         return h("span",params.row.title);
        }
      },
      { title: '操作', key: 'action', align: 'center',width:100,
        render: (h, params) => {
          let btns = []
          btns.push(
              h('Button', {
                props: { type: 'info', size: 'small' },
                style: { marginRight: '5px', marginBottom: '5px'},
                on: {
                  click: () => {
                    this.showComponentEdit = true;
                    this.componentEditForm.studio_id=params.row.studio_id;
                    this.componentEditForm.id=params.row.id;
                    this.componentEditForm.name=params.row.name;
                    this.componentEditForm.unit_type = Number(params.row.unit_type);
                    this.componentEditForm.studio_page_id = params.row.studio_page_id;
                    this.componentEditForm.attr = params.row.attr;
                  }
                }
              }, '编辑'),
          );
          btns.push(
              h('Button', {
                props: { type: 'error', size: 'small' },
                style: { marginRight: '5px', marginBottom: '5px'},
                on: {
                  click: () => {
                    this.componentDelForm.id = params.row.id;
                    this.componentDelForm.studio_id=params.row.studio_id;
                    this.componentDelForm.studio_page_id = params.row.studio_page_id;
                    this.delStudioUnit();
                  }
                }
              }, '删除'),
          );
          return h("div",btns);
        }
      },
    ],
		uploadHeader:{
		  "Authorization":localStorage.getItem('token')
		},
	}
  },
  mounted:function(){
	  this.getTagList();
    this.getStudioList();
	  this.getSetting();
    this.getUnitType();
  },
  computed:{
	  getUploadUrl(){
	      return process.env.VUE_APP_APIHOST+'/admin/material/upload';
	  }
  },
  methods:{
	getTagList() {
		this.http.get('/admin/studio/tags').then(response=>{
		  let data = response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.tag_list = data.data;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
	getStudioList(page=this.page) {
		this.page = page;
		let p = {'page' : page}
		let params = Object.assign(this.search, p);
		this.http.get('/admin/studio/templeteList',{params:params}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.studio_list = data.data.list;
			this.recordTotal = data.data.total;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
	updateStudio(){
		this.http.post('/admin/studio/updateStudio',{
				  id:this.studio.id,
				  name:this.studio.name,
				  seq:this.studio.seq,
				  tag_id:this.studio.tag_id,
				  video:this.studio.video,
				  cover:this.studio.cover,
				  channel:this.studio.channel,
          ext_attr: this.studio.ext_attr,
      templet_position:this.studio.templet_position,
		}).then(response=>{
		  let data=response.data;
		  if(data.code!==0) {
		    this.$Message.error(data.message);
		    return false;
		  } else{
		    this.$Message.info(data.message);
		    this.showmodal = false;
			this.getStudioList();
		    return true;
		  }
		});
	},
	getSetting() {
		this.http.get('/admin/common/settingKey',{params:{'key':'app_channel'}}).then(response=>{
		  let data=response.data;
		  console.log(data);
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.channel_list = data.data;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
	successUpload(response, file, fileList){
	    let data=response
	    if(data.code!=0) {
	        this.$Message.error(data.message);
	        return true;
	    }
	    this.studio.video = data.data.url;
		this.$Message.success('上传成功');
		//this.$refs.audio.src = data.data.url+"?ran=" + Math.random();
	},
	successCover(response, file, fileList){
	    let data=response
	    if(data.code!=0) {
	        this.$Message.error(data.message);
	        return true;
	    }
	    this.studio.cover = data.data.url;
		this.$Message.success('上传成功');
	},
    closeModal(){
		this.studio.id = 0;
		this.studio.name = '';
		this.studio.seq = 0;
		this.studio.tag_id = [];
		this.showmodal=false;
    },
	setTemplate(studio_id,studio_type){
		this.$Modal.confirm({
			content: '<p>确认取消模板？取消后进入13000000001账户</p>',
			onOk: () => {
				this.http.post('/admin/studio/setTemplate',{
					studio_id:studio_id,
					template:2,
					studio_type:studio_type
				}).then(response=>{
				  let data=response.data;
				  if(data.code!==0) {
				    this.$Message.error(data.message);
				    return false;
				  } else{
				    this.$Message.info(data.message);
				    this.showmodal = false;
					this.getStudioList();
				    return true;
				  }
				});
			}
		});
		
	},
    getStudioUnitList(page=1){
      this.componentSearch.page = page
      this.http.get('/admin/studio/studioUnitList',{params:this.componentSearch}).then(response=>{
        let data=response.data;
        console.log(data);
        if(data.code!==0){
          alert(data.message);
        } else{
          this.studio_unit_list = data.data.list;
          this.componentsTotal = data.data.total;
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
    addComponent(){
      this.showComponentAdd=true;
      this.componentAddForm.studio_id=this.currentStudioId;
    },
    addStudioUnit(){
      this.http.post('/admin/studio/addStudioUnit',this.componentAddForm).then(response=>{
        let data=response.data;
        if(data.code!==0) {
          this.$Message.error(data.message);
          return false;
        } else{
          this.$Message.info(data.message);
          this.showComponentAdd = false;
          this.getStudioUnitList();
          return true;
        }
      });
    },
    editStudioUnit(){
      this.http.post('/admin/studio/updateStudioUnit',this.componentEditForm).then(response=>{
        let data=response.data;
        if(data.code!==0) {
          this.$Message.error(data.message);
          return false;
        } else{
          this.$Message.info(data.message);
          this.showComponentEdit = false;
          this.getStudioUnitList();
          return true;
        }
      });
    },
    delStudioUnit(){
      this.$Modal.confirm({
        title: '删除',
        content: '<p>确认要删除该条记录？</p>',
        onOk: () => {
          this.http.post('/admin/studio/deleteStudioUnit',this.componentDelForm).then(response=>{
            let data=response.data;
            if(data.code!==0) {
              this.$Message.error(data.message);
              return false;
            } else{
              this.$Message.info("删除成功");
              this.getStudioUnitList();
              return true;
            }
          });
        },
        onCancel: () => {
          this.$Message.info('已取消');
        }
      });
    },
    getUnitType(){
      this.http.get('/admin/studio/getStudioUnitType').then(response=>{
        let data=response.data;
        console.log(data);
        if(data.code!==0){
          alert(data.message);
        } else{
          this.unitTypeList = data.data
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
    getStudioPage(){
      this.http.get('/admin/studio/getStudioPageList',{params:{"studio_id": this.currentStudioId}}).then(response=>{
        let data=response.data;
        console.log(data);
        if(data.code!==0){
          alert(data.message);
        } else{
          this.pageList = data.data;
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    }
  }

}
</script>
